module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAwCAYAAABe6Vn9AAABJ0lEQVRoQ+3X0W3CQBCE4Z8O6IASoAOgAzogVJZQAVAB0AF0EDqghGgl3zMg7cxF1t4TD/bCN3M29oSRrcnIPBTovzdaDVVD5gRqy5kD//jrqqGPIzOfUA29EfgCeAK/bxybfoiioSOwBNbALf0XvxioAE2BCzDrgVKAIsNuKBWooWL7zZ1NKUFtt/8AW2AHxGfpcoACYEO5QDaUE2RBuUFyVA9QoL6Ab8WNohcoHo8OwB3YZN72eoACcwYewGp47kszuUFSTKTiBMkxTpAF4wLZMA5Qw1yHW3W8+EmX8hpqmNOAkULacBWo/XHunRjVluuGUYHaO0/A7Eu15ewQ9TVUoKwEastlJamaUw2pks2aWw1lJamaUw2pks2aWw1lJamaM7qG/gBq2DExinJ4+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blackArrowRightIcon.png
// module id = ufTC
// module chunks = 13